<template>
  <el-dialog
    ref="userDialog"
    :visible.sync="config.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="!isDesktop"
    :show-close="false"
    :top="marginTop"
    :custom-class="isDesktop ? 'pop_page noscroll' : 'pop_page noscroll headless'"
  >
    <div v-if="isDesktop" slot="title" class="header">
      <div class="left">
        &nbsp;
      </div>
      <div class="middle">
        <span v-if="!(loginUserId && config.userid === loginUserId)">{{ $t('i.homepage') }}</span>
        <span v-if="loginUserId && config.userid === loginUserId">{{ title }}</span>
      </div>
      <div class="float-right align-right">
        <el-button v-if="!(loginUserId && config.userid === loginUserId)" class="tap-btn" @click="showActionSheet">
          <i class="iconfont my-dot-more" />
        </el-button>
        <el-button class="tap-btn iconfont my-close size20" @click="close" />
        &nbsp;
      </div>
    </div>
    <div v-show="config.show" class="my-container">
      <div v-if="config.mng !== 'yes'">
        <div v-if="(isDesktop && largeMod) || !isDesktop" ref="header-card" class="header-card" :style="cardStyle">
          <div v-if="!isDesktop" class="header">
            <div class="left">
              <el-button v-if="!config.hideBack" class="tap-btn" @click="close">
                <i class="iconfont my-back" />
              </el-button>
              <span v-if="config.hideBack">&nbsp;</span>
            </div>
            <div class="middle">
              <span v-if="largeMod || config.userid === loginUserId">{{ (config.userid !== loginUserId || isDesktop) ? $t('i.homepage') : $t('i.mine') }}</span>
              <div v-if="!largeMod && config.userid !== loginUserId" class="user">
                <div class="l">
                  <span v-if="!user.avatar" class="el-avatar el-avatar--circle noavatar small">
                    <i class="iconfont my-man" />
                  </span>
                  <el-avatar v-if="user.avatar" :size="24" :src="getAvatar()" />
                </div>
                <div class="m">
                  {{ user.nickname || view.anonymity }}
                </div>
                <div class="r">
                  <el-button v-if="(followState[config.userid] === 0)" class="tap-btn on opacity-bg" @click="unfollow(config.userid)">{{ $t('i.hadFollow') }}</el-button>
                  <el-button v-if="(followState[config.userid] === 1)" class="tap-btn on opacity-bg" @click="unfollow(config.userid)">{{ $t('i.followEach') }}</el-button>
                  <el-button v-if="(followState[config.userid] !== 0 && followState[config.userid] !== 1)" class="tap-btn opacity-bg" @click="follow(config.userid)">{{ $t('i.follow') }}</el-button>
                </div>
              </div>
            </div>
            <div class="right">
              <el-button class="tap-btn" @click="moreAction">
                <i class="iconfont my-dot-more" />
              </el-button>
            </div>
          </div>
          <div v-if="largeMod" class="my-row user-info">
            <div class="avatar" @click="setProfile()">
              <span v-if="!(user.avatar && !config.loading)" class="el-avatar el-avatar--circle noavatar xlarge">
                <i class="iconfont my-man" />
              </span>
              <el-avatar v-if="user.avatar && !config.loading" :size="64" :src="getAvatar()" />
              <!-- <span v-if="isVip" class="iconfont my-vip vip-tag opacity-bg yellow" /> -->
            </div>
            <div class="info">
              <span class="name" @click="setProfile()">{{ user.nickname || view.anonymity }}</span>
              <span v-if="isVip || config.userid === loginUserId" class="addition opacity-bg iconfont my-vip color-ee" :class="{'yellow': isVip}" :title="$t('i.vip')" @click="goto('vip')" />
              <span v-if="user.is_creator" class="addition opacity-bg">{{ $t('i.creator') }}</span>
              <span v-if="user.is_publisher" class="addition opacity-bg">{{ $t('i.pubOrg') }}</span>
              <br>
              <el-button class="tap-btn opacity-bg size16 iconfont my-praise-blank" @click="alert($t('i.praiseCount', { liked_count: user.liked_count }))" /><span class="size14 margin-left4">{{ user.liked_count || 0 }}</span>
              <el-button class="tap-btn opacity-bg size16 iconfont my-follow margin-left8" @click="goto('relation', { type: 'follow', userid: config.userid })" /><span class="size14 margin-left4">{{ user.follow_count || 0 }}</span>
              <el-button class="tap-btn opacity-bg size16 iconfont my-fans margin-left8" @click="goto('relation', { type: 'fans', userid: config.userid })" /><span class="size14 margin-left4">{{ user.fans_count || 0 }}</span>
              <el-button v-if="config.userid === loginUserId && guests" class="tap-btn opacity-bg iconfont size16 my-guest margin-left8" @click="goto('relation', { type: 'guest', userid: config.userid })" /><span v-if="config.userid === loginUserId && guests" class="size14 margin-left4">{{ guests }}</span>
            </div>
            <div v-if="isDesktop && largeMod && config.userid !== loginUserId" class="btns padding-top24 padding-right4 float-right">
              <el-button class="tap-btn opacity-bg margin-right12" style="width:110px;" @click="emit('goto', ['chat', { userid: config.userid, nickname: user.nickname }])">{{ $t('i.msg') }}</el-button>
              <el-button v-if="(followState[config.userid] === 0)" style="width:110px;" class="tap-btn opacity-bg" @click="unfollow(config.userid)">{{ $t('i.hadFollow') }}</el-button>
              <el-button v-if="(followState[config.userid] === 1)" style="width:110px;" class="tap-btn opacity-bg" @click="unfollow(config.userid)">{{ $t('i.followEach') }}</el-button>
              <el-button v-if="(followState[config.userid] !== 0 && followState[config.userid] !== 1)" style="width:110px;" class="tap-btn opacity-bg" @click="follow(config.userid)">{{ $t('i.follow') }}</el-button>
            </div>
          </div>
          <div v-if="largeMod && user.signature" class="my-row padding-bottom4 margin-left10 margin-right10">
            <span v-html="getSign(user.signature)" />
          </div>
          <div v-if="!isDesktop && largeMod && config.userid !== loginUserId" class="my-row btns padding-top4 padding-bottom4">
            <el-button class="tap-btn opacity-bg margin-left10" @click="emit('goto', ['chat', { userid: config.userid, nickname: user.nickname }])">{{ $t('i.msg') }}</el-button>
            <el-button v-if="(followState[config.userid] === 0)" class="tap-btn opacity-bg" @click="unfollow(config.userid)">{{ $t('i.hadFollow') }}</el-button>
            <el-button v-if="(followState[config.userid] === 1)" class="tap-btn opacity-bg" @click="unfollow(config.userid)">{{ $t('i.followEach') }}</el-button>
            <el-button v-if="(followState[config.userid] !== 0 && followState[config.userid] !== 1)" class="tap-btn opacity-bg" @click="follow(config.userid)">{{ $t('i.follow') }}</el-button>
          </div>
        </div>
        <div v-if="!isDesktop && largeMod && config.userid === loginUserId" ref="user-btns" class="user-btns padding-top4">
          <div class="bg-22 padding8 margin-top2">
            <el-row>
              <el-col :span="4">
                <el-badge :value="formateNums(state.unread.total)" :hidden="!state.unread.total">
                  <el-button class="tap-btn" @click="goto('message')">
                    <i class="iconfont my-message" />
                  </el-button>
                  <br> {{ $t('i.message') }}
                </el-badge>
              </el-col>
              <el-col :span="4">
                <el-button class="tap-btn" @click="goto('task')">
                  <i class="iconfont my-task" />
                </el-button>
                <br> {{ $t('i.task') }}
              </el-col>
              <el-col :span="4">
                <el-button class="tap-btn" @click="goto('sign')">
                  <i class="iconfont my-sign" />
                </el-button>
                <br> {{ $t('i.sign') }}
              </el-col>
              <el-col :span="4">
                <el-button class="tap-btn" @click="goto('items')">
                  <i class="iconfont my-items" />
                </el-button>
                <br> {{ $t('i.items') }}
              </el-col>
              <!-- <el-col :span="5">
                <el-button class="tap-btn" @click="goto('nft')">
                  <i class="iconfont my-nft" />
                </el-button>
                <br> {{ $t('i.nft') }}
              </el-col> -->
              <el-col :span="4">
                <el-button class="tap-btn" @click="goto('wallet')">
                  <i class="iconfont my-worth" />
                </el-button>
                <br> {{ $t('i.money') }}
              </el-col>
              <!-- <el-col :span="5">
                <el-button class="tap-btn" @click="goto('order')">
                  <i class="iconfont my-orders" />
                </el-button>
                <br> 订单
              </el-col> -->
              <el-col :span="4">
                <el-button class="tap-btn" @click="goto('services')">
                  <i class="iconfont my-circle-grid" />
                </el-button>
                <br> {{ $t('i.all') }}
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="5">
                <el-button class="tap-btn" @click="goto('draft')">
                  <i class="iconfont my-material" />
                </el-button>
                <br> {{ $t('i.draf') }}
              </el-col>
              <el-col :span="5">
                <el-button class="tap-btn" @click="goto('download')">
                  <i class="iconfont my-down-round" />
                </el-button>
                <br> {{ $t('i.download') }}
              </el-col>
              <el-col :span="5">
                <el-button class="tap-btn" @click="goto('favor')">
                  <i class="iconfont my-blank-star" />
                </el-button>
                <br> {{ $t('i.favor') }}
              </el-col>
              <el-col :span="5">
                <el-button class="tap-btn" @click="goto('praise')">
                  <i class="iconfont my-praise-blank" />
                </el-button>
                <br> {{ $t('i.praise') }}
              </el-col>
              <el-col :span="5">
                <el-button class="tap-btn" @click="goto('footprint')">
                  <i class="iconfont my-footprint" />
                </el-button>
                <br> {{ $t('i.footprint') }}
              </el-col>
              <el-col :span="5">
                <el-button class="tap-btn" @click="goto('invite')">
                  <i class="iconfont my-invite" />
                </el-button>
                <br> {{ $t('i.invit') }}
              </el-col>
            </el-row> -->
          </div>
        </div>
      </div>
      <div class="tabs my-tabs" :class="{'bg-20' : isDesktop, 'flex' : !isDesktop}" :style="{'padding' : isDesktop ? '3px' : '', 'padding-top': (!isDesktop && config.mng === 'yes') ? '0px' : '' }">
        <el-col :span="isDesktop ? 18 : 19" class="padding-left8">
          <el-menu v-if="loginUserId && config.userid === loginUserId" :default-active="config.type" menu-trigger="click" :unique-opened="true" mode="horizontal" @select="handleSelect">
            <el-menu-item index="thread">{{ $t('i.topic') }}</el-menu-item>
            <el-submenu index="worksMenu">
              <template slot="title">{{ $t('i.works') }}</template>
              <el-menu-item index="works">{{ $t('i.public') }}</el-menu-item>
              <el-menu-item index="worksPrivate">{{ $t('i.private') }}</el-menu-item>
            </el-submenu>
            <el-submenu index="albumMenu">
              <template slot="title">{{ $t('i.album') }}</template>
              <el-menu-item index="album">{{ $t('i.public') }}</el-menu-item>
              <el-menu-item index="albumPrivate">{{ $t('i.private') }}</el-menu-item>
            </el-submenu>
            <el-submenu index="nftMenu">
              <template slot="title">{{ $t('i.nfts') }}</template>
              <el-menu-item index="nft">{{ $t('i.public') }}</el-menu-item>
              <el-menu-item index="nftPrivate">{{ $t('i.private') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-menu v-if="!(loginUserId && config.userid === loginUserId)" :default-active="config.type" menu-trigger="click" :unique-opened="true" mode="horizontal" @select="handleSelect">
            <el-menu-item index="thread">{{ $t('i.topic') }}</el-menu-item>
            <el-menu-item index="works">{{ $t('i.works') }}</el-menu-item>
            <el-menu-item index="album">{{ $t('i.album') }}</el-menu-item>
            <el-menu-item index="nft">{{ $t('i.nfts') }}</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="isDesktop ? 6 : 5" class="btns align-right" :class="{'padding-top4': !isDesktop, 'padding-top2': isDesktop}">
          <el-button class="tap-btn margin-right4 bg-22" style="width: 30px;" @click="handleAdd">
            <i class="iconfont my-square-add color-ee" />
          </el-button>
          <el-button v-if="config.mng !== 'yes'" class="tap-btn bg-22" style="width: 30px;" @click="toggleHead">
            <i v-if="!largeMod" class="iconfont my-open-down color-ee" />
            <i v-if="largeMod" class="iconfont my-close-up color-ee" />
          </el-button>
        </el-col>
      </div>
      <thread-list
        v-show="config.show && config.type === 'thread'"
        ref="thread-list"
        mod="user"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
      <works-list
        v-show="config.show && config.type === 'works'"
        ref="works-list"
        mod="user"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
      <works-list
        v-show="config.show && config.type === 'worksPrivate'"
        ref="works-private-list"
        mod="userPrivate"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
      <album-list
        v-show="config.show && config.type === 'album'"
        ref="album-list"
        mod="user"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
      <album-list
        v-show="config.show && config.type === 'albumPrivate'"
        ref="album-private-list"
        mod="userPrivate"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
      <nft-list
        v-show="config.show && config.type === 'nft'"
        ref="nft-list"
        mod="user"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
      <nft-list
        v-show="config.show && config.type === 'nftPrivate'"
        ref="nft-private-list"
        mod="userPrivate"
        :subtract-height="subtractHeight"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :show-footbar="showFootbar"
        :is-pop="true"
        @receive="handle"
      />
    </div>
    <div solt="footer">
      <foot-bar
        v-if="showFootbar"
        ref="footBar"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        @receive="handle"
      />
    </div>
  </el-dialog>
</template>
<script>
import conf from '@/js/conf/conf'
import utils from '@/js/utils'
import service from '@/js/service'
import worksList from '@/components/web/worksList'
import threadList from '@/components/web/threadList'
import albumList from '@/components/web/albumList'
import nftList from '@/components/web/nftList'
import { mixins } from '@/mixins/common'
import footBar from '@/components/web/footBar'
export default {
  components: {
    worksList,
    threadList,
    albumList,
    nftList,
    footBar
  },
  mixins: [mixins],
  props: {
    showFootbar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      worksHost: conf.hosts().worksHost,
      cdnHost: conf.hosts().cdnHost,
      swipeLock: false,
      hideHead: false,
      scrollTop: 0,
      subtractHeight: 180,
      guests: 0,
      user: {}
    }
  },
  computed: {
    isVip() {
      return this.user.groupid > 10 && new Date(this.user.expired_at) > new Date()
    },
    title() {
      if (this.config.mng !== 'yes') return this.$t('i.homepage')
      const types = { 'thread': this.$t('i.topic'), 'works': this.$t('i.works'), 'album': this.$t('i.album'), 'nft': this.$t('i.nfts') }
      const k = this.config.type.replace('Private', '')
      return types[k] ? (this.$t('i.my') + ' ' + (this.config.type.split('Private').length > 1 ? this.$t('i.private') + ' ' : '') + types[k]) : this.$t('i.homepage')
    },
    largeMod() {
      return !this.hideHead
    },
    cardStyle() {
      const style = {}
      let bg = this.getBackground()
      // if (!bg) bg = this.worksHost + utils.getDefaultBg(this.user.userid || 0) + '/background'
      if (!bg) bg = this.cdnHost + utils.getDefaultBg(this.user.userid || 0)
      if (bg && this.largeMod && !this.view.user.loading) {
        style['background-image'] = 'url(' + bg + ')'
        style['background-position'] = 'center center'
        style['background-size'] = '100% auto'
        style['background-repeat'] = 'no-repeat'
        if (this.isDesktop) {
          style['padding-top'] = '10px'
          style['border-radius'] = '4px'
        }
      } else {
        style['padding-top'] = '30px'
      }
      return style
    },
    config() {
      return this.view.user
    },
    types() {
      return this.config.types()
    },
    publicTypes() {
      const types = []
      if (this.types.length) {
        for (const i in this.types) {
          if (!this.types[i][2]) types.push(this.types[i])
        }
      }
      return types
    }
  },
  watch: {
    // 'view.user.show': {
    //   handler() {
    //     if (this.view.user.show) {
    //       this.updateData()
    //       this.autoAcceptTask()
    //       this.view.user.loading = false
    //       if (this.config.userid && this.config.userid !== this.user.userid) {
    //         this.hideHead = false
    //         this.config.type = this.config.type || 'thread'
    //         this.config.typeid = this.config.typeid || 0
    //         this.guests = 0
    //         this.getUser(true)
    //       }
    //       this.update()
    //     }
    //   }
    // },
    // 'view.user.userid': {
    //   handler() {
    //     if (this.view.user.show) {
    //       this.addFootprint()
    //       if (this.config.userid && this.config.userid !== this.user.userid) {
    //         this.hideHead = false
    //         this.config.type = this.config.type || 'thread'
    //         this.config.typeid = this.config.typeid || 0
    //         this.guests = 0
    //         this.getUser(true)
    //       }
    //     }
    //   }
    // },
    'view.user.renew': {
      handler() {
        this.getUser(true)
      }
    }
  },
  mounted() {
    this.view.user.userid = this.view.user.userid || this.loginUserId
    if (!this.view.user.userid) {
      this.emit('login')
      return
    }
    this.addFootprint()
    if (this.view.user.userid && this.view.user.userid === this.loginUserId) {
      this.autoAcceptTask()
    }
    this.view.user.type = this.view.user.type || 'thread'
    this.view.user.typeid = this.view.user.typeid || 0
    this.hideHead = false
    this.view.user.loading = false
    this.guests = 0
    this.getUser(true)
  },
  methods: {
    updateData() {
      this.callSub(utils.snakeCase(this.config.type) + '-list', 'updateData')
    },
    toggleHead() {
      this.hideHead = !this.hideHead
      this.update()
    },
    handleSelect(key, path) {
      this.config.type = path[path.length - 1]
    },
    handleAdd() {
      const actions = {
        show: true,
        title: this.$t('i.pleaseSel'),
        btns: []
      }
      actions.btns = actions.btns.concat([
        // { title: this.$t('i.editer'), cb: () => { this.goto('editer') } },
        // { title: this.$t('i.createPixelPuzzle'), cb: () => { this.emit('openPopPage', [{ 'type': 'toBrickfy' }]) } },
        // { title: this.$t('i.aiBeadsPixel'), cb: () => { this.emit('openPopPage', [{ 'type': 'toBeadsPixel' }]) } },
        // { title: this.$t('i.aiCartoon'), cb: () => { this.emit('openPopPage', [{ 'type': 'toCartoon' }]) } },
        // { title: this.$t('i.aiart'), cb: () => { this.emit('openAiPaint', []) } },
        { title: this.$t('i.addPost'), cb: () => { this.openPost({}) } },
        { title: this.$t('i.newAlbum'), cb: () => { this.emit('openResourceMng', [{ 'table': 'album', 'act': 'add' }]) } }
      ])
      this.view.actionSheet = actions
    },
    close() {
      this.closePop(this.config)
      if (this.view.mod === 'editer') this.goto('index')
    },
    // 转场
    goto(mod, dt) {
      if (mod === 'user') return
      this.emit('goto', [mod, dt])
    },
    handle(act, data) {
      if (act === 'setLockSwipe') {
        this.swipeLock = data[0]
      } else if (act === 'setScrollTop') {
        this.setScrollTop(...data)
      } else if (act === 'goto') {
        this.goto(...data)
      } else if (act === 'update') {
        this.update()
      } else {
        this.emit(act, data)
      }
    },
    // onSwipeTab(evt) {
    //   if (this.swipeLock) return
    //   const config = utils.deepClone(this.config)
    //   if (!(this.loginUserId && config.userid === this.loginUserId)) {
    //     config.types = this.publicTypes
    //   }
    //   const newConfig = this.switchTab(config, evt.direction)
    //   this.config.type = newConfig.type
    // },
    setScrollTop(scrollTop) {
      this.scrollTop = scrollTop
      this.update()
    },
    moreAction() {
      if (this.loginUserId && this.config.userid === this.loginUserId) return this.goto('setup')
      this.showActionSheet()
    },
    showActionSheet() {
      const actions = {
        show: true,
        title: this.$t('i.pleaseSel'),
        btns: []
      }
      const userid = this.user.userid
      actions.btns.push({ title: this.$t('i.msg'), cb: () => {
        this.emit('goto', ['chat', { userid: userid, nickname: this.user.nickname }])
      } })
      if (this.followState[userid] !== 0 && this.followState[userid] !== 1) {
        actions.btns.push({ title: this.$t('i.follow'), cb: () => {
          this.follow(userid)
        } })
      } else {
        actions.btns.push({ title: this.$t('i.cancelFollow'), cb: () => {
          this.unfollow(userid)
        } })
      }
      actions.btns = actions.btns.concat([
        { title: this.$t('i.advertisingGarbage'), cb: () => { this.emit('reports', [userid, 0, this.$t('i.advertisingGarbage'), this.loginUserId]) } },
        { title: this.$t('i.violationContent'), cb: () => { this.emit('reports', [userid, 0, this.$t('i.violationContent'), this.loginUserId]) } },
        { title: this.$t('i.maliciousWatering'), cb: () => { this.emit('reports', [userid, 0, this.$t('i.maliciousWatering'), this.loginUserId]) } },
        { title: this.$t('i.repeatPosting'), cb: () => { this.emit('reports', [userid, 0, this.$t('i.repeatPosting'), this.loginUserId]) } },
        { title: this.$t('i.otherReasons'), cb: () => { this.emit('setReportReason', [userid, 0, this.loginUserId]) } }
      ])
      this.view.actionSheet = actions
    },
    getSign(content) {
      if (!content) return ''
      return utils.fomateContent(content)
    },
    getAvatar() {
      const ver = Math.round(new Date(this.user.avatar_at) / 1000)
      if (this.user.avatar) return service.getCosUrl(this.user.avatar, 'avatar', ver) || ''
    },
    getBackground() {
      const ver = Math.round(new Date(this.user.background_at) / 1000)
      if (this.user.background) return service.getCosUrl(this.user.background, 'background', ver) || ''
    },
    formateTime: utils.formateTime,
    formateNums: utils.formateNums,
    getElementHeight(refid) {
      return this.$refs[refid] ? parseInt(window.getComputedStyle(this.$refs[refid]).height) : 0
    },
    setProfile() {
      if (this.config.userid && this.config.userid === this.loginUserId) this.goto('profile')
    },
    update() {
      this.$forceUpdate()
      setTimeout(() => {
        const cardHeight = this.getElementHeight('header-card')
        const userBtnsHeight = this.getElementHeight('user-btns')
        this.subtractHeight = cardHeight + userBtnsHeight + 40
        if (this.showFootbar) this.subtractHeight = this.subtractHeight + 50
      }, 10)
    },
    renewView() {
      this.callSub(this.config.type + '-list', 'renewView')
    },
    callSub(ref, fn) {
      const el = this.$refs[ref]
      if (el && el[fn]) {
        el[fn]()
      } else {
        setTimeout(() => {
          this.callSub(ref, fn)
        }, 100)
      }
    },
    // 关注
    follow(userid) {
      this.followState[userid] = 1
      this.update()
      this.$refs['thread-list'].update()
      this.emit('follow', [userid, (res, type) => {
        if (type === 'success') {
          this.followState[userid] = res.isMutual
        } else {
          // 回滚
          this.followState[userid] = -1
          this.message(res, type)
        }
        this.update()
        this.$refs['thread-list'].update()
      }])
    },
    // 取消关注
    unfollow(userid) {
      this.followState[userid] = -1
      this.update()
      this.$refs['thread-list'].update()
      this.emit('unfollow', [userid, (res, type) => {
        if (type === 'success') {
          this.followState[userid] = -1
        } else {
          // 回滚
          this.followState[userid] = 0
          this.message(res, type)
        }
        this.update()
        this.$refs['thread-list'].update()
      }])
    },
    getUser(renew) {
      if (this.view.user.loading) return
      this.view.user.loading = true
      this.emit('getUser', [this.config.userid || this.loginUserId, (user) => {
        if (user) {
          this.user = user
          this.config.userid = user.userid
          this.setCount()
        }
        this.view.user.loading = false
        this.update()
      }])
      if (renew) this.renewView()
    },
    // 自动接受任务
    autoAcceptTask() {
      this.emit('autoAcceptTask', [(dt, type) => {
        if (type === 'success' && dt && dt.data && dt.data.count) this.view.task.init = utils.time('time')
        // TODO: 显示未完成的任务数
        this.update()
      }])
    },
    addFootprint() {
      service.get('home_view', this.config.userid, (dt, type) => {
        if (type === 'success') this.guests = dt.data.guests
      })
    },
    // 设置计数器(新手任务)
    setCount() {
      const user = this.user
      if (user.userid !== this.loginUserId || !this.loginUserId) return
      if (user.avatar) service.setCount(user.userid, 'avatar', 1)
      if (user.background) service.setCount(user.userid, 'background', 1)
      if (user.signature) service.setCount(user.userid, 'signature', 1)
      if (user.username) service.setCount(user.userid, 'username', 1)
    }
  }
}
</script>
